export const RUTA_SELECCION_CUENTA = '/seleccion-cuenta'

/**
 * PBI 81715: ADMIN ART/HYS siempre ve "Seleccionar cuenta"; el resto de los
 * perfiles la ve solo con más de una cuenta.
 *
 * Todos van a la pantalla React de selección: la grilla para usuarios comunes
 * (PBI #80498) y el buscador para Admin ART/HyS (PBI #80676). La vista se
 * elige dentro de la pantalla según el rol.
 *
 * `externa` indica cómo navegar: true → window.location, false → navigate().
 *
 * @param {Object} params
 * @param {boolean} params.esAdminARToHyS
 * @param {number}  params.cantidadContratos
 * @returns {{ mostrarSeleccionCuenta: boolean, externa: boolean, url: string }}
 */
export function resolveSeleccionCuenta({ esAdminARToHyS, cantidadContratos }) {
  return {
    mostrarSeleccionCuenta: esAdminARToHyS || cantidadContratos > 1,
    externa: false,
    url: RUTA_SELECCION_CUENTA,
  }
}
